import { render, staticRenderFns } from "./UserStyles.vue?vue&type=template&id=0b83d4fc&scoped=true&"
import script from "./UserStyles.vue?vue&type=script&lang=js&"
export * from "./UserStyles.vue?vue&type=script&lang=js&"
import style0 from "./UserStyles.vue?vue&type=style&index=0&id=0b83d4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83d4fc",
  null
  
)

export default component.exports